export class KpisDiaModel {
  totalVendido: number;
  quantidadePedidos: number;
  ticketMedio: number;
  vendedoresAtivos: number;
  pedidosAguardandoErp: number;
}

export function emptyKpisDia(): KpisDiaModel {
  return {
    totalVendido: 0,
    quantidadePedidos: 0,
    ticketMedio: 0,
    vendedoresAtivos: 0,
    pedidosAguardandoErp: 0,
  };
}
